import initDropdown from "../components/initDropdown.js";

document.addEventListener("DOMContentLoaded", () => {

    initDropdown();

    let extraFilters = {};

    async function loadParticipants(url) {
        try {
            const response = await axios.get(url, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });

            if (response.status === 200) {
                const wrapper = document.querySelector('#participants-table-wrapper');
                if (wrapper) wrapper.outerHTML = response.data.html;
            }

        } catch (error) {
            console.error('Error loading items:', error);
        }
    }

    async function applyFilters(url) {

        window.history.pushState({}, '', url);
        await loadParticipants(url);

        syncActiveButtons();

    }

    function updateDropdownParams() {
        const dropdowns = document.querySelectorAll('.dropdown__block');
        const params = new URLSearchParams();

        params.set('page', 1);

        dropdowns.forEach(dropdown => {
            const menu = dropdown.querySelector('.dropdown__block_menu');
            if (!menu) return;

            const name = menu.dataset.dropdownName || menu.querySelector('[data-dropdown-name]')?.dataset.dropdownName;
            if (!name) return;

            const selected = Array.from(menu.querySelectorAll('.dropdown__block_menu_item.selected'))
                .map(i => i.dataset.dropdownValue)
                .filter(Boolean);

            if (selected.length > 0) {
                params.set(name, selected.join(','));
            }
        });

        Object.entries(extraFilters).forEach(([key, value]) => {
            params.set(key, value);
        });

        return window.location.pathname + '?' + params.toString().replace(/%2C/g, ',');
    }

    function syncActiveButtons() {

        const currentParams = new URLSearchParams(window.location.search);

        const current = {};
        currentParams.forEach((value, key) => {
            if (key !== 'page') {
                current[key] = value;
            }
        });

        document.querySelectorAll('[data-set-filter], [data-reset-filters]')
            .forEach(btn => btn.classList.remove('text-primary'));

        const hasFilters = Object.keys(current).length > 0;

        if (!hasFilters) {
            const resetBtn = document.querySelector('[data-reset-filters]');
            if (resetBtn) resetBtn.classList.add('text-primary');
            return;
        }

        document.querySelectorAll('[data-set-filter]').forEach(btn => {

            const btnParams = new URLSearchParams(btn.dataset.setFilter);

            let match = true;

            btnParams.forEach((value, key) => {
                if (current[key] !== value) {
                    match = false;
                }
            });

            if (match && Object.keys(current).length === [...btnParams.keys()].length) {
                btn.classList.add('text-primary');
            }

        });

    }

    document.addEventListener('click', e => {

        const item = e.target.closest('[data-dropdown-menu-trigger]');
        if (!item) return;

        extraFilters = {};

        const currentParams = new URLSearchParams(window.location.search);
        currentParams.delete('paid');

        const url = updateDropdownParams();
        applyFilters(url).then(r => {});

    });

    document.addEventListener('click', e => {

        const resetBtn = e.target.closest('[data-reset-filters]');
        if (resetBtn) {

            document.querySelectorAll('.dropdown__block_menu_item.selected')
                .forEach(el => el.classList.remove('selected'));

            extraFilters = {};
            const url = updateDropdownParams();
            applyFilters(url).then(r => {});
            return;
        }

        const trigger = e.target.closest('[data-set-filter]');
        if (!trigger) return;

        const filters = new URLSearchParams(trigger.dataset.setFilter);

        document.querySelectorAll('.dropdown__block_menu_item.selected')
            .forEach(el => el.classList.remove('selected'));

        extraFilters = {};

        filters.forEach((value, key) => {

            const item = document.querySelector(
                `.dropdown__block_list[data-dropdown-name="${key}"]
             .dropdown__block_menu_item[data-dropdown-value="${value}"]`
            );

            if (item) {
                item.classList.add('selected');
            } else {
                extraFilters[key] = value;
            }

        });

        const url = updateDropdownParams();
        applyFilters(url).then(r => {});

    });

});
